import React from 'react'
import {createSearchParams, Link, useNavigate, useSearchParams} from "react-router-dom";
import Sidebar from "../../../../../components/Sidebar";
import PageHeader from "../../../../../components/PageHeader";
import {toast} from "react-toastify";
import DatePicker, {registerLocale} from "react-datepicker";
import {getSchoolYear} from "../../../../../utils/authority";
import vi from "date-fns/locale/vi";
import FoodController from "../../../../../services/system/food/food-controller";
import Utils from "../../../../../utils/utils";
registerLocale("vi", vi);
function withRouter(Component) {
    return (props) => <Component {...props} navigate={useNavigate()} params={useSearchParams()} />;
}
class EditFoodManagement extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            listFoodCategory: [],
            listGroup: [],
            listProvider: [],
            name: "",

            "calcium": 0,
            "phosphorus": 0,
            "iron": 0,
            "vitaminA": 0,
            "vitaminB1": 0,
            "vitaminB2": 0,
            "vitaminC": 0,
            "vitaminPP": 0,

            pageNumber: 0,
            pageSize: 10,
        };
    }

    componentWillMount() {
        const [searchparams] = this.props.params;
        let foodId = searchparams.get("id");
        this.getFoodDetail(foodId)
        this.getListFoodCategory()
        this.getListFoodGroup()
        this.getListSupplier()
    }
    renderStatus() {
        let listStatus = [
            {
                "id": "All",
                "name": "Tất cả"
            },
            {
                "id": "PENDING",
                "name": "Chưa thanh toán"
            },
            {
                "id": "PAYMENT",
                "name": "Đã thánh toán"
            },

        ]
        return listStatus.map((item, index) => <option
            value={item.id}>{item.name}</option>)
    }
    onCreate = () => {
        let protit = parseFloat(this.state.protit)
        let lipit = parseFloat(this.state.lipit)
        let gluxit = parseFloat(this.state.gluxit)
        let calo = parseFloat(this.state.calo)
        let price = parseFloat(this.state.unitPrice.toString().replaceAll(",", ""))
        if (this.state.name == ""){
            toast.error("Vui lòng nhập tên thực phẩm");
        }else if(this.state.categoryId < 0){
            toast.error("Vui lòng chọn loại thực phẩm");
        }else if(this.state.groupId < 0){
            toast.error("Vui lòng chọn nhóm thực phẩm");
        }else if(this.state.providerId < 1){
            toast.error("Vui lòng chọn nhà cung cấp");
        }else if(isNaN(protit) || isNaN(lipit) || isNaN(gluxit) || isNaN(calo) || protit <= 0 || lipit<=0 || gluxit<=0 || calo <= 0){
            toast.error("Vui lòng điền các thành phần chính");
        }
        else {
            let payload = {
                "id": this.state.id,
                "name": this.state.name,
                "code":this.state.code,
                "wareHouse": this.state.wareHouse,
                "rationDispose": this.state.rationDispose,
                "unitCalculate": this.state.unitCalculate,
                "unitPrice": price,
                "usual": this.state.usual,

                "calo": calo,
                "gluxit": gluxit,
                "lipit": lipit,
                "protit": protit,
                "providerId": parseInt(this.state.providerId),
                "groupId": parseInt(this.state.groupId),
                "categoryId": parseInt(this.state.categoryId),

                "calcium": this.state.calcium,
                "phosphorus": this.state.phosphorus,
                "iron": this.state.iron,
                "vitaminA": this.state.vitaminA,
                "vitaminB1": this.state.vitaminB1,
                "vitaminB2": this.state.vitaminB2,
                "vitaminC": this.state.vitaminC,
                "vitaminPP": this.state.vitaminPP,
                yearId: parseInt(getSchoolYear()),
            }
            FoodController.editFood(payload, res => {
                if (res.success){
                    toast.success("Lưu thực phẩm thành công!")
                    this.setState({
                        showLoading: false,
                    });
                } else {
                    toast.error("Đã xảy ra lỗi! " + res.message)
                }
            })
        }
    }

    getFoodDetail(foodId) {
        FoodController.detailFood(foodId, res => {
            this.setState(res.data);
        })
    }
    getListFoodCategory() {
        let payload = {
            yearId: parseInt(getSchoolYear()),
            pageNumber: 0,
            pageSize: 1000,
            sort: "created_at desc",
            name: "",
        };
        FoodController.searchCategory(payload, res => {
            this.setState({
                showLoading: false,
                listFoodCategory: res.data.content,
            });
        })
    }
    getListFoodGroup() {
        let payload = {
            yearId: parseInt(getSchoolYear()),
            pageNumber: 0,
            pageSize: 1000,
            sort: "created_at desc",
            name: "",
        };
        FoodController.searchGroup(payload, res => {
            if (res.success){
                this.setState({
                    listGroup: res.data.content,
                })
            }else {
                toast.error("Đã xảy ra lỗi! " + res.message)
            }
        })
    }
    getListSupplier() {
        let payload = {
            yearId: parseInt(getSchoolYear()),
            pageNumber: 0,
            pageSize: 1000,
            sort: "created_at desc",
            name: "",
        };
        FoodController.searchProvider(payload, res => {
            this.setState({
                listProvider: res.data.content,
            });
        })
    }
    renderFoodCategory() {
        return this.state.listFoodCategory.map((item, index) => <option
            value={item.id}>{item.name}</option>)
    }
    renderGroup() {
        return this.state.listGroup.map((item, index) => <option
            value={item.id}>{item.name}</option>)
    }
    renderProvider() {
        return this.state.listProvider.map((item, index) => <option
            value={item.id}>{item.name}</option>)
    }
    render() {
        return (
            <div>
                <div className="container">
                    <div className="row">
                        <Sidebar activeClass="food" parentClass="menu-management"/>
                        <div className="mb-4 col-md-10 tab-content">
                            <div className="card col-12">
                                <div className='pt-3 mb-2'>
                                    <PageHeader routerEnable={true} title="Thêm mới thực phẩm"/>
                                    <div className="mt-4 kt-form kt-form--fit kt-margin-b-20">
                                        <h2 className='text-center mb-4'>Thêm mới thực phẩm</h2>
                                        <div className="row">
                                            <div className="col-12 d-flex mb-2 bg-top-title mt-2">
                                                Thông tin thực phẩm
                                            </div>
                                            <div className="col-xs-12 col-sm-12 col-md-6 d-flex mb-2">
                                                <label className="col-4 label-item pl-0">Tên thực phẩm(<span  style={{color: "red",}}>*</span>)</label>
                                                <input
                                                    placeholder="Tên thực phẩm"
                                                    maxLength={255} type="text"
                                                    className="form-control shadow-none"
                                                    value={this.state.name}
                                                    onChange={(event) => {
                                                        this.setState({
                                                            name: event.target.value
                                                        })
                                                    }}
                                                />
                                            </div>
                                            <div className="col-xs-12 col-sm-12 col-md-6 d-flex mb-2">
                                                <label className="col-4 label-item pl-0">Mã thực phẩm(<span  style={{color: "red",}}>*</span>)</label>
                                                <input
                                                    placeholder="Mã thực phẩm"
                                                    maxLength={255} type="text"
                                                    className="form-control shadow-none"
                                                    value={this.state.code}
                                                    onChange={(event) => {
                                                        this.setState({
                                                            code: event.target.value
                                                        })
                                                    }}
                                                />
                                            </div>
                                            <div className="col-xs-12 col-sm-12 col-md-6 d-flex mb-2">
                                                <label className="col-4 label-item pl-0">Nhóm thực phẩm(<span  style={{color: "red",}}>*</span>)</label>
                                                <select
                                                    className="form-control kt-input pd-4-input hei-input"
                                                    value={this.state.groupId}
                                                    onChange={(e) => {
                                                        this.setState({
                                                            groupId: e.target.value,
                                                        })
                                                    }}
                                                >
                                                    <option value="">Chọn nhóm thực phẩm</option>
                                                    {this.renderGroup()}
                                                </select>
                                            </div>
                                            <div className="col-xs-12 col-sm-12 col-md-6 d-flex mb-2">
                                                <label className="col-4 label-item pl-0">Tỷ lệ thải bỏ(%)</label>
                                                <input
                                                    placeholder="Tỷ lệ thải bỏ"
                                                    maxLength={255} type="text"
                                                    className="form-control shadow-none"
                                                    value={this.state.rationDispose}
                                                    onChange={(event) => {
                                                        this.setState({
                                                            rationDispose: event.target.value
                                                        })
                                                    }}
                                                />
                                            </div>
                                            <div className="col-xs-12 col-sm-12 col-md-6 d-flex mb-2">
                                                <label className="col-4 label-item pl-0">Loại thực phẩm(<span  style={{color: "red",}}>*</span>)</label>
                                                <select
                                                    className="form-control kt-input pd-4-input hei-input"
                                                    value={this.state.categoryId}
                                                    onChange={(e) => {
                                                        this.state.gender = e.target.value;
                                                        this.setState({
                                                            categoryId: e.target.value
                                                        })
                                                    }}
                                                >
                                                    <option value="">Chọn loại thực phẩm</option>
                                                    {this.renderFoodCategory()}
                                                </select>
                                            </div>
                                            <div className="col-xs-12 col-sm-12 col-md-6 d-flex mb-2">
                                                <label className="col-4 label-item pl-0">Đơn giá (VND)</label>
                                                <input
                                                    placeholder="Đơn giá"
                                                    maxLength={255} type="text"
                                                    className="form-control shadow-none"
                                                    value={Utils.formatMoney(this.state.unitPrice)}
                                                    onChange={(event) => {
                                                        this.setState({
                                                            unitPrice: event.target.value
                                                        })
                                                    }}
                                                />
                                            </div>
                                            <div className="col-xs-12 col-sm-12 col-md-6 d-flex mb-2">
                                                <label className="col-4 label-item pl-0">Nhà cung cấp</label>
                                                <select
                                                    className="form-control kt-input pd-4-input hei-input"
                                                    value={this.state.providerId}
                                                    onChange={(e) => {
                                                        this.state.providerId = e.target.value;
                                                        this.setState({
                                                            providerId: e.target.value,
                                                            inEditing: true
                                                        })
                                                    }}
                                                >
                                                    <option value="">Chọn nhà cung cấp</option>
                                                    {this.renderProvider()}
                                                </select>
                                            </div>
                                            <div className="col-xs-12 col-sm-12 col-md-6 d-flex mb-2">
                                                <label className="col-4 label-item pl-0">Đơn vị tính</label>
                                                <input
                                                    placeholder="Đơn vị tính"
                                                    maxLength={255} type="text"
                                                    className="form-control shadow-none"
                                                    value={this.state.unitCalculate}
                                                    onChange={(event) => {
                                                        this.setState({
                                                            unitCalculate: event.target.value
                                                        })
                                                    }}
                                                />
                                            </div>

                                            <div className="col-xs-12 col-sm-12 col-md-6 d-flex mb-2">
                                                <label className="col-4 label-item pl-0">Thường dùng</label>
                                                <select
                                                    className="form-control kt-input pd-4-input hei-input"
                                                    value={this.state.usual}
                                                    onChange={(e) => {
                                                        this.setState({
                                                            usual: e.target.value,
                                                        })
                                                    }}
                                                >
                                                    <option value="true">Có</option>
                                                    <option value="false">Không</option>
                                                </select>
                                            </div>
                                            <div className="col-xs-12 col-sm-12 col-md-6 d-flex mb-2">
                                                <label className="col-4 label-item pl-0">Chợ/Kho</label>
                                                <select
                                                    className="form-control kt-input pd-4-input hei-input"
                                                    value={this.state.wareHouse}
                                                    onChange={(e) => {
                                                        this.setState({
                                                            wareHouse: e.target.value,
                                                        })
                                                    }}
                                                >
                                                    <option value="true">Chợ</option>
                                                    <option value="false">Kho</option>
                                                </select>
                                            </div>

                                            <div className="col-12 d-flex mb-2 bg-top-title mt-2">
                                                Thành phần dinh dưỡng
                                            </div>

                                            <div className="col-12 d-flex row mt-3">
                                                <div className="col-12 d-flex mb-2">
                                                    <label className="col-12 label-item pl-0"><b>Thành phần chính</b></label>
                                                </div>
                                                <div className="col-xs-12 col-sm-12 col-md-3 d-flex mb-2">
                                                    <label className="col-7 label-item pl-0">Đạm(g) <span  style={{color: "red",}}>*</span></label>
                                                    <input
                                                        placeholder="0g"
                                                        type="number"
                                                        className="form-control shadow-none"
                                                        value={this.state.protit}
                                                        onChange={(event) => {
                                                            this.setState({
                                                                protit: event.target.value
                                                            })
                                                        }}
                                                    />
                                                </div>
                                                <div className="col-xs-12 col-sm-12 col-md-3 d-flex mb-2">
                                                    <label className="col-7 label-item pl-0">Béo(g) <span  style={{color: "red",}}>*</span></label>
                                                    <input
                                                        placeholder="0g"
                                                        type="number"
                                                        className="form-control shadow-none"
                                                        value={this.state.lipit}
                                                        onChange={(event) => {
                                                            this.setState({
                                                                lipit: event.target.value
                                                            })
                                                        }}
                                                    />
                                                </div>
                                                <div className="col-xs-12 col-sm-12 col-md-3 d-flex mb-2">
                                                    <label className="col-7 label-item pl-0">Đường(g) <span  style={{color: "red",}}>*</span></label>
                                                    <input
                                                        placeholder="0g"
                                                        type="number"
                                                        className="form-control shadow-none"
                                                        value={this.state.gluxit}
                                                        onChange={(event) => {
                                                            this.setState({
                                                                gluxit: event.target.value
                                                            })
                                                        }}
                                                    />
                                                </div>
                                                <div className="col-xs-12 col-sm-12 col-md-3 d-flex mb-2">
                                                    <label className="col-7 label-item pl-0">Calo(Kcal) <span  style={{color: "red",}}>*</span></label>
                                                    <input
                                                        placeholder="0g"
                                                        type="number"
                                                        className="form-control shadow-none"
                                                        value={this.state.calo}
                                                        onChange={(event) => {
                                                            this.setState({
                                                                calo: event.target.value
                                                            })
                                                        }}
                                                    />
                                                </div>
                                            </div>
                                            <div className="col-12 d-flex row mt-3">
                                                <div className="col-12 d-flex mb-2">
                                                    <label className="col-12 label-item pl-0"><b>Khoáng chất và vi lượng</b></label>
                                                </div>
                                                <div className="col-xs-12 col-sm-12 col-md-3 d-flex mb-2">
                                                    <label className="col-7 label-item pl-0">Canxi(mg)</label>
                                                    <input
                                                        placeholder="0g"
                                                        type="number"
                                                        className="form-control shadow-none"
                                                        value={this.state.calcium}
                                                        onChange={(event) => {
                                                            this.setState({
                                                                calcium: event.target.value
                                                            })
                                                        }}
                                                    />
                                                </div>
                                                <div className="col-xs-12 col-sm-12 col-md-3 d-flex mb-2">
                                                    <label className="col-7 label-item pl-0">Photpho(mg)</label>
                                                    <input
                                                        placeholder="0g"
                                                        type="number"
                                                        className="form-control shadow-none"
                                                        value={this.state.phosphorus}
                                                        onChange={(event) => {
                                                            this.setState({
                                                                phosphorus: event.target.value
                                                            })
                                                        }}
                                                    />
                                                </div>
                                                <div className="col-xs-12 col-sm-12 col-md-3 d-flex mb-2">
                                                    <label className="col-7 label-item pl-0">Sắt(mg)</label>
                                                    <input
                                                        placeholder="0g"
                                                        type="number"
                                                        className="form-control shadow-none"
                                                        value={this.state.iron}
                                                        onChange={(event) => {
                                                            this.setState({
                                                                iron: event.target.value
                                                            })
                                                        }}
                                                    />
                                                </div>
                                                <div className="col-xs-12 col-sm-12 col-md-3 d-flex mb-2">
                                                    <label className="col-7 label-item pl-0">VitaminA(mg)</label>
                                                    <input
                                                        placeholder="0g"
                                                        type="number"
                                                        className="form-control shadow-none"
                                                        value={this.state.vitaminA}
                                                        onChange={(event) => {
                                                            this.setState({
                                                                vitaminA: event.target.value
                                                            })
                                                        }}
                                                    />
                                                </div>
                                                <div className="col-xs-12 col-sm-12 col-md-3 d-flex mb-2">
                                                    <label className="col-7 label-item pl-0">VitaminB1(mg)</label>
                                                    <input
                                                        placeholder="0g"
                                                        type="number"
                                                        className="form-control shadow-none"
                                                        value={this.state.vitaminB1}
                                                        onChange={(event) => {
                                                            this.setState({
                                                                vitaminB1: event.target.value
                                                            })
                                                        }}
                                                    />
                                                </div>
                                                <div className="col-xs-12 col-sm-12 col-md-3 d-flex mb-2">
                                                    <label className="col-7 label-item pl-0">VitaminB2(mg)</label>
                                                    <input
                                                        placeholder="0g"
                                                        type="number"
                                                        className="form-control shadow-none"
                                                        value={this.state.vitaminB2}
                                                        onChange={(event) => {
                                                            this.setState({
                                                                vitaminB2: event.target.value
                                                            })
                                                        }}
                                                    />
                                                </div>
                                                <div className="col-xs-12 col-sm-12 col-md-3 d-flex mb-2">
                                                    <label className="col-7 label-item pl-0">VitaminPP(mg)</label>
                                                    <input
                                                        placeholder="0g"
                                                        type="number"
                                                        className="form-control shadow-none"
                                                        value={this.state.vitaminPP}
                                                        onChange={(event) => {
                                                            this.setState({
                                                                vitaminPP: event.target.value
                                                            })
                                                        }}
                                                    />
                                                </div>
                                                <div className="col-xs-12 col-sm-12 col-md-3 d-flex mb-2">
                                                    <label className="col-7 label-item pl-0">VitaminC(mg)</label>
                                                    <input
                                                        placeholder="0g"
                                                        type="number"
                                                        className="form-control shadow-none"
                                                        value={this.state.vitaminC}
                                                        onChange={(event) => {
                                                            this.setState({
                                                                vitaminC: event.target.value
                                                            })
                                                        }}
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="align-right col-12">
                                    <div className="d-flex justify-content-center align-center mt-3 mb-2">
                                        <button
                                            type="button"
                                            className="ml-4 border-1-s background-btn type-button-fix btn btn-primary shadow-none"
                                            disabled={this.state.name == ""}
                                            onClick={()=> {
                                                this.onCreate()
                                            }}
                                        >
                                            Lưu
                                        </button>
                                        <button
                                            type="button"
                                            className="ml-4  border-1-s type-button-fix btn btn-light shadow-none"
                                        >
                                            <Link
                                                style={{color: '#000'}}
                                                to={{
                                                    pathname: "/ad-sas-school/danh-sach-dang-ky-xe-bus"
                                                }}
                                            >
                                                Hủy bỏ
                                            </Link>
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}
export default withRouter(EditFoodManagement)